import "../chunk-7D4SUZUM.js";

// src/i18n/index.ts
import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next, I18nextProvider } from "react-i18next";
import React from "react";
async function initI18n(config) {
  if (i18next.isInitialized) return i18next;
  const namespaces = config.namespaces ?? ["translation"];
  const storageKey = config.storageKey ?? "i18n-locale";
  const instance = i18next.use(LanguageDetector).use(initReactI18next);
  if (config.backend === "http") {
    const HttpBackend = (await import("i18next-http-backend")).default;
    instance.use(HttpBackend);
  }
  await instance.init({
    lng: config.defaultLocale,
    fallbackLng: config.defaultLocale,
    supportedLngs: config.locales,
    ns: namespaces,
    defaultNS: namespaces[0],
    ...config.backend === "static" && config.resources ? { resources: config.resources } : {},
    ...config.backend === "http" && config.translationsPath ? { backend: { loadPath: config.translationsPath } } : {},
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: storageKey,
      caches: ["localStorage"]
    },
    interpolation: { escapeValue: false }
  });
  return i18next;
}
function createI18nTestWrapper(resources, lng = "en", config) {
  const instance = i18next.createInstance();
  const namespaces = config?.namespaces ?? ["translation"];
  const fallbackLng = config?.fallbackLng ?? lng;
  const firstLocale = Object.values(resources)[0];
  const isNamespaceStructured = firstLocale != null && Object.values(firstLocale).every(
    (v) => typeof v === "object" && v !== null && !Array.isArray(v)
  );
  const structuredResources = isNamespaceStructured ? resources : Object.fromEntries(
    Object.entries(resources).map(([locale, translations]) => [
      locale,
      { [namespaces[0]]: translations }
    ])
  );
  instance.use(initReactI18next).init({
    lng,
    fallbackLng,
    resources: structuredResources,
    ns: namespaces,
    defaultNS: namespaces[0],
    interpolation: { escapeValue: false }
  });
  const wrapper = ({ children }) => React.createElement(I18nextProvider, { i18n: instance }, children);
  return { wrapper, i18n: instance };
}
export {
  createI18nTestWrapper,
  initI18n
};
//# sourceMappingURL=index.js.map